var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 247,
    viewBox: "0 0 248 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 123.5,
    r: 123.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.219 54.0508H83.5859V180.086H181.586V79.8282L156.219 54.0508ZM135.18 153.015H98.2874V145.285H135.18V153.015ZM151.899 138.698H98.2874V130.963L151.899 130.964V138.698ZM151.899 122.799H98.2874V115.063L151.899 115.064V122.799ZM151.031 85.5612V60.9268L175.818 85.5612H151.031Z",
    fill: "#CACDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6857 67.3887H65.4121V198.951H171.089V187.454H76.686L76.6857 67.3887Z",
    fill: "#CACDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsPlaceholder);
export default __webpack_public_path__ + "static/media/DocumentsPlaceholder.e64db7d9090434e3a579fb1c040205e3.svg";
export { ForwardRef as ReactComponent };